var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQrBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 383,
    height: 300,
    viewBox: "0 0 383 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_931_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M382 21C382 9.95433 373.046 1 362 1H21C9.95428 1 0.999969 9.9543 0.999969 21V255.745C0.999969 266.79 9.95428 275.745 21 275.745H90.3894C92.947 275.745 95.4809 276.235 97.8537 277.19L150.713 298.454C153.742 299.672 157.042 297.443 157.042 294.179C157.042 283.998 165.295 275.745 175.476 275.745H362C373.046 275.745 382 266.79 382 255.745V21Z",
    fill: "url(#paint0_linear_931_2)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382 21C382 9.95433 373.046 1 362 1H21C9.95428 1 0.999969 9.9543 0.999969 21V255.745C0.999969 266.79 9.95428 275.745 21 275.745H90.3894C92.947 275.745 95.4809 276.235 97.8537 277.19L150.713 298.454C153.742 299.672 157.042 297.443 157.042 294.179C157.042 283.998 165.295 275.745 175.476 275.745H362C373.046 275.745 382 266.79 382 255.745V21Z",
    stroke: "url(#paint1_linear_931_2)",
    strokeOpacity: 0.3,
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_931_2",
    x: -30,
    y: -30,
    width: 443,
    height: 359.793,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_931_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_931_2",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_931_2",
    x1: 188.967,
    y1: 151,
    x2: 167.572,
    y2: 326.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFDFD",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_931_2",
    x1: -160.151,
    y1: 244.243,
    x2: 351.121,
    y2: -82.0899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrBox);
export default __webpack_public_path__ + "static/media/qrBox.5465a4b289adc1e7aa5d21b7643a92c2.svg";
export { ForwardRef as ReactComponent };